const $ = window.$;
// progress indicator for wizards
export default function(id) {
	this.id = id;
	this.$outer = $('#' + id);

	let _$steps = this.$outer.find('.js-prog-bar-step');

	function _fill() {
		var i = 0;
		var currentStep = this.$outer.data().currentStep || 0;

		if (currentStep) {
			do {
				_$steps[i].classList.add('is-filled');
				i++;
			} while (i < currentStep);
		}
	}

	function _cacheSelectors() {
		this.$outer = $('#' + id);

		_$steps = this.$outer.find('.js-prog-bar-step');
	}



	this.init = function() {
		_cacheSelectors.call(this);
		_fill.call(this);
	};
}